export default Object.freeze({
  CLP_PROMOTED_BOX: 'CLP_PROMOTED_BOX',
  FREEHTML: 'FREEHTML',
  GRAPHIC_BANNER: 'GRAPHIC_BANNER',
  OFFERS_MINI_BANNER: 'OFFERS_MINI_BANNER',
  SUPPLIER_SEARCH_PROMOTED_BOX: 'SUPPLIER_SEARCH_PROMOTED_BOX',
});
